<template>
  <div class="admin-login-wrap d-flex align-items-center justify-content-center">
    <div class="card shadow" style="width: 400px;">
      <div class="card-body p-4">
        <div class="text-center mb-4">
          <div class="admin-badge mb-2">ADMIN</div>
          <h5 class="fw-bold mb-0">은평구시설관리공단 관리자</h5>
        </div>

        <div class="mb-3">
          <label class="form-label">관리자 아이디</label>
          <input v-model="form.username" type="text" class="form-control" @keyup.enter="login" />
        </div>

        <div class="mb-4">
          <label class="form-label">비밀번호</label>
          <input v-model="form.password" type="password" class="form-control" @keyup.enter="login" />
        </div>

        <div v-if="error" class="alert alert-danger py-2">{{ error }}</div>

        <button class="btn btn-primary w-100" :disabled="loading" @click="login">
          {{ loading ? '로그인 중...' : '관리자 로그인' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AdminLoginView',
  data() {
    return {
      form: { username: '', password: '' },
      loading: false,
      error: null
    }
  },
  methods: {
    async login() {
      this.error = null
      if (!this.form.username || !this.form.password) {
        this.error = '아이디와 비밀번호를 입력하세요.'
        return
      }
      this.loading = true
      try {
        const res = await axios.post(`${process.env.VUE_APP_API_BASE}/api/admin/login`, this.form)
        sessionStorage.setItem('adminUser', JSON.stringify(res.data.user))
        // notify other components in the same window about auth change
        try { window.dispatchEvent(new Event('admin-auth-changed')) } catch (e) { /* ignore */ }
        this.$router.push('/admin/dashboard')
      } catch (e) {
        this.error = e.response?.data?.message || '로그인에 실패했습니다.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.admin-login-wrap {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 60%, #0f3460 100%);
}

.admin-badge {
  display: inline-block;
  background: #e63946;
  color: white;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 2px;
  padding: 3px 10px;
  border-radius: 4px;
}
</style>
